import React from 'react';
import { Star, Quote } from 'lucide-react';

interface TestimonialProps {
  quote: string;
  author: string;
  rating: number;
}

const Testimonial: React.FC<TestimonialProps> = ({ quote, author, rating }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100 hover:shadow-lg transition-all duration-300">
      <div className="mb-4 flex justify-between items-center">
        <Quote className="text-accent/30" size={32} />
        <div className="flex">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star 
              key={i} 
              size={16} 
              className={i < rating ? "text-yellow-400 fill-yellow-400" : "text-gray-300"} 
            />
          ))}
        </div>
      </div>
      <p className="text-gray-700 mb-4">{quote}</p>
      <p className="font-semibold text-primary">{author}</p>
    </div>
  );
};

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      quote: "Graças ao trabalho da Dra. Lidiane, consegui recuperar todo o valor bloqueado da minha conta em menos de uma semana!",
      author: "Maria S.",
      rating: 5
    },
    {
      quote: "Atendimento rápido e eficiente. Resolveram meu problema quando outros advogados disseram que seria impossível.",
      author: "Carlos A.",
      rating: 5
    },
    {
      quote: "Profissionalismo e competência. Recomendo a todos que estão passando por problemas com bloqueio judicial de contas.",
      author: "Patricia M.",
      rating: 4
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl mb-4 text-primary text-center">
          O QUE NOSSOS CLIENTES DIZEM
        </h2>
        <p className="text-center text-gray-600 max-w-2xl mx-auto mb-10">
          Veja como temos ajudado pessoas a recuperarem os valores bloqueados em suas contas
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Testimonial 
              key={index} 
              quote={testimonial.quote} 
              author={testimonial.author} 
              rating={testimonial.rating} 
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;